import { helper } from './helper';

export const entityType = helper.accessor('type', {
  header: 'Type',
});
